import { getDefaultDescription } from '@shared/prosemirror/getDefaultDescription';
import { createState } from '@store/utils/createState';

import { type Permission } from './types';

export const initialState = (): Permission => ({
  id: '',
  name: '',
  description: getDefaultDescription(),
  slug: '',
  permissionFor: [],
  group: {
    id: '',
    name: '',
    slug: '',
  },
});

export const {
  state: mePermissionState,
  listState: mePermissionsState,
  idsState: mePermissionIdsState,
} = createState({ initialState });
